//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const snackCravings = useStore((state) => state.snackCravings);
  const setSnackCravings = useStore((state) => state.setSnackCravings);

  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.snackCravings.title')}</Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {t('onboarding.snackCravings.description')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={snackCravings}
          onChange={(value) => {
            setSnackCravings(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'snack-cravings',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Mornings'}>{t('onboarding.snackCravings.options.mornings')}</Option>
          <Option value={'Afternoon'}>{t('onboarding.snackCravings.options.afternoon')}</Option>
          <Option value={'Evenings'}>{t('onboarding.snackCravings.options.evenings')}</Option>
          <Option value={'Late at night'}>{t('onboarding.snackCravings.options.late')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
